import ArrayProxy from "@ember/array/proxy"
import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import _ from "lodash"
const ArrayPromiseProxy = ArrayProxy.extend(PromiseProxyMixin)
const ObjectPromiseProxy = ObjectProxy.extend(PromiseProxyMixin)

/**
 * A macro that returns a computed property that returns an array of proxy objects
 *
 * @param  {String} keyName
 * @param  {String} relationshipType
 * @return {Array<ObjectPromiseProxy>} - an array of proxy objects whose values can be accessed via
 * the content property on each item
 */
export default function findMany(keyName, relationshipType) {
  /**
   * Example

    ``` javascript
      class exampleComponent extends Component {
        courseIds = [ 1, 2, 3, 4 ]
        @findMany("courseIds", "course") selectedCourses
      }
    ```

   */
  return computed(`${keyName}.[]`, function () {
    let ids = get(this, keyName)
    if (get(this, "store") === undefined)
      throw Error("You need to inject the store to use the findMany function")
    return _.map(ids, (id) => {
      return ObjectPromiseProxy.create({
        promise: get(this, "store").find(relationshipType, id),
      })
    })
  })
}
